import { render, staticRenderFns } from "./slsnzForm.vue?vue&type=template&id=48321c1d&scoped=true&"
import script from "./slsnzForm.vue?vue&type=script&lang=js&"
export * from "./slsnzForm.vue?vue&type=script&lang=js&"
import style0 from "./slsnzForm.vue?vue&type=style&index=0&id=48321c1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48321c1d",
  null
  
)

export default component.exports
import QForm from 'quasar/src/components/form/QForm.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QForm,QTabs,QTab,QInput,QIcon});
